import React, { useEffect, useState } from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    IconButton,
    Chip,
    Button,
    Typography
} from '@mui/material';
import pdf from '../../../assets/Project_Images/Icons/pdf.png'
import reciept from '../../../assets/Project_Images/Icons/reciept.png'
import details from '../../../assets/Project_Images/Icons/details.png'
import { DatePicker, LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { ApiGetInvoiceList } from '../../../../apiService/Core/Apicall.tsx';
import dayjs, { Dayjs } from 'dayjs';
import { toast } from 'react-toastify';
import InvoiceListing from './InvoiceListing.tsx';
import { useLocation } from 'react-router-dom';
import Invoicedetails from './Invoicedetails.tsx';



function Invoices() {
    const [selectedDate, setselectedDate] = useState<Dayjs>(dayjs());
    const location = useLocation().pathname


    // const isSelected = (invoice: string) => selected.includes(invoice);
    // console.log("location", location)

    // const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     if (event.target.checked) {
    //         const all = invoicelist.map((row) => row.invoice);
    //         setSelected(all);
    //     } else {
    //         setSelected([]);
    //     }
    // };

    // const handleClick = (invoice: string) => {
    //     const selectedIndex = selected.indexOf(invoice);
    //     let newSelected: string[] = [];

    //     if (selectedIndex === -1) {
    //         newSelected = [...selected, invoice];
    //     } else {
    //         newSelected = selected.filter((id) => id !== invoice);
    //     }

    //     setSelected(newSelected);
    // };
    // useEffect(() => {
    //     console.log(selected)
    // }, [selected])




    const InvoiceComponent = () => {
        switch (location) {
            case '/dashboard/invoices/invoice-details':
                return <Invoicedetails selectedDate={selectedDate} />
                break;

            default:
                return <InvoiceListing selectedDate={selectedDate} />
                break;
        }
    }
    return (
        <Box className='mt-1 invoice p-3'>
            <Box className='d-flex align-items-center mb-4  justify-content-between'>
                <Typography className='fw-bold' variant='h6'>Invoice Listing</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker sx={{ width: {xs:"30%",lg:'15%'} }} value={selectedDate} onChange={(newvalue) => { newvalue && setselectedDate(newvalue) }} views={['month', 'year']} />
                </LocalizationProvider>

            </Box>
            <InvoiceComponent />

        </Box>
    );
}

export default Invoices;
